import { QueueBatch } from '../../lib/types/models/queue/queue-batch.model'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getBatchesProgress(id: number) {
  return restApiClient.url(constructApiUrl(API.queues.getBatches.url, { id })).get<QueueBatch[]>()
}
